export const UserState = {
    action: "",
    userID: 0,
    firstName: "",
    lastName: "",
    mobile: "",
    initials: "",
    email: "",
    passwordHash: "",
    confirmPassword: "",
    roleID: 0,
    profileImage: null
};

export const leadData = {
    leadID: 0,
    firstName: "",
    surname: "",
    followUp: "",
    email: "",
    mobile: "",
    source: "",
    staff: "",
    stage: "",
    CreatedBy: "system",
    financeApproval: "",
    maxPropertyPrice: "",
    propertyType: "",
    propertyPurpose: "",
    LeadPropertyLocation: "",
    location_Beds_Baths_Cars: "",
    taxableIncome: "",
    cashInBank: "",
    combinedSuper: "",
    personalLoans: "",
    creditCardLimits: "",
    CommentText: "",
    realEstateAgent1: "",
    realEstateAgent2: "",
    realEstateAgent3: "",
    propertyReady: "",
    propertyTop3: "",
    businessLoan: "",
    mortgageMastery: "",
};

export const propertyData = {
    propertyId: 0,
    clientId: 0,
    supplier: "",
    contractType: "",
    stateId: "",
    area: "",
    propertyName: "",
    companyName: "",
    propertyAddress: "",
    suburb: "",
    postcode: "",
    propertyState: "",
    propertyType: "",
    offThePlan: "",
    price1Bedroom: "0",
    price2Bedroom: "0",
    levels: 0,
    noOfUnits: 0,
    summary: "",
    bedrooms: "",
    design: "",
    fascade: "",
    bath: "",
    car: "",
    internalSQM: "",
    externalSQM: "",
    housePrice: "",
    houseSize: "",
    landPrice: "",
    landSize: "",
    titled: "",
    storey: "",
    rentDollar: "",
    rentTerm: "",
    showers: "0",
    carspots: "0",
    estCapitalGrowth: "",
    vacancyRate: "",
    starRating: "0",
    floorImage: "",
    rentYield: "",
    isTitled: true,
    brochurePdf: "",
    rentGuaranteed: "",
    packageInclusions: "",
    subdivisionImage: "",
    housePriceSqm: "",
    landPriceSqm: "",
    estate: "",
    lotNumber: "",
    MemberPimage: null,
    email: "",
    mobile: "",
    NDISimageFile: null,
    BuilderFaçadePageimageFile: null,
    FloorPlanimageFile: null,
    InclusionsimageFile: null,
    SubdivisionimageFile: null,
    EstateimageFile: null,
    brochurepdffile: null,
}

export const buildersData = {
    // supplierId: null,
    supplier: "",
    firstName: "",
    lastName: "",
    address: "",
    suburb: "",
    postcode: "",
    stateId: "0",
    areaId: "0",
    suburbId: "0",
    email: "",
    mobile: "",
    // createdOn: null,
    isDeleted: false,
    propertyImage: "",
    initial: "",
    builderType: "Select",
    bdmFirstName: "",
    bdmLastName: "",
    bdmMobile: "",
    bdmTelePhone: "",
    bdmEmail: "",
    accFirstName: "",
    accLastName: "",
    accMobile: "",
    accTelePhone: "",
    accEmail: "",
    url: "",
    username: "",
    password: "",
    vic: false,
    qld: false,
    nsw: false,
    sa: false,
    wa: false,
    duplex: false,
    co_Living: false,
    ndis: false,
    pdf: "",
    telePhone: "",
    updateOn: "",
    qldNorth: false,
    portalList: "",
    comments: "",
    newComment: "",
    packageInclusions: "",
    townhouse: false,
    landOnly: false,
    houseLand: false,
    apartment: false,
    commissionPaid: "",
    buildFacade: "",
    apartmentCommission: "",
    colivingCommission: "",
    duplexCommission: "",
    houseLandCommission: "",
    ndisCommission: "",
    landCommission: "",
    townhouseCommission: "",
    apartmentQLD: false,
    c: false,
    duplexQLD: false,
    houseLandQLD: false,
    ndisQLD: false,
    landQLD: false,
    townhouseQLD: false,
    apartmentNSW: false,
    colivingNSW: false,
    duplexNSW: false,
    houseLandNSW: false,
    ndisNSW: false,
    landNSW: false,
    townhouseNSW: false,
    apartmentSA: false,
    colivingSA: false,
    duplexSA: false,
    houseLandSA: false,
    ndisSA: false,
    landSA: false,
    townhouseSA: false,
    apartmentWA: false,
    colivingWA: false,
    duplexWA: false,
    houseLandWA: false,
    ndisWA: false,
    landWA: false,
    townhouseWA: false,
    apartmentVIC: false,
    colivingVIC: false,
    duplexVIC: false,
    houseLandVIC: false,
    ndisVIC: false,
    landVIC: false,
    townhouseVIC: false,
    consFirstName: "",
    consLastName: "",
    consMobile: "",
    consTelePhone: "",
    consEmail: "",
    townhouseQLDNTH: false,
    landQLDNTH: false,
    ndisQLDNTH: false,
    houseLandQLDNTH: false,
    duplexQLDNTH: false,
    colivingQLDNTH: false,
    colivingQLD: false,
    apartmentQLDNTH: false,
    PropertyImageFile: null,
    BuildFacadeFile: null,
}

export const crmLeadFactFindData = {
    // Client 1 Details
    firstName: "",
    surname: "",
    client1Dob: "",
    mobile: "",
    email: "",
    client1MaritalStatus: "",
    client1ResidencyStatus: "",
    client1CreditStatus: "",
    client1Dependants: "",
    client1CurrentAddress: "",
    client1PreviousAddress: "",

    // Client 2 Details
    client2FirstName: "",
    client2Surname: "",
    client2Dob: "",
    client2Mobile: "",
    client2Email: "",
    client2MaritalStatus: "",
    client2ResidencyStatus: "",
    client2CreditStatus: "",
    client2Dependants: "",
    client2CurrentAddress: "",
    client2PreviousAddress: "",

    // Common Fields
    source: "",
    staff: "",
    stage: "",
    followUp: "",

    // Client 1 Employment Details
    client1EmploymentType: "",
    client1JobTitle: "",
    client1TimeInWorkYear: "",
    client1PreviousWork: "",
    client1TaxableIncome: "",

    client2EmploymentType: "",
    client2JobTitle: "",
    client2TimeInWorkYear: "",
    client2PreviousWork: "",
    client2TaxableIncome: "",
};
